export const configKeys = {
  /**
   * Config key for the thieme connector api uri
   * @type {string}
   */
  THIEME_CONNECTOR_URI_CONFIG_KEY: 'apis.thieme.connector.uri',

  /**
   * Config key for questionnaire uri (used to save/delete imported questionnaires)
   * @type {string}
   */
  QUESTIONNAIRE_URI_CONFIG_KEY: 'apis.questionnaire.uri',

  /**
   * Config key for the thieme license feature flag
   * @type {string}
   */
  FEATURE_THIEME_CONFIG_KEY: 'feature.thieme'
};
